import React from 'react';

import { getApp } from '../../../index';

// This component is used only to render optional data field (e.g. middle name, mailing address(if different to residential address), Co-App info, and etc.) 
class ReviewItem extends React.Component {

    render() {
        var appVal = getApp(this.props.appKey);
        let item;
        // let itemClass;


        if (appVal !== "") {
            item = (
                <span>{this.props.label} <strong>{String(appVal)}</strong></span>
            );
        } else {
            item = "";
        }
        return (
            <span>{item}</span>
        )
    }
}

export default ReviewItem;